import { useState } from 'react';
import { GapDetailView, bookGap, fillOurselves, gapById, pauseGap, recentGapDetail, resumeGap, skipCandidate } from '@elva/ui';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

/**
 * A gap in detail (amendment 26 §3) — `/ai-team/gap-filler/<gap>`. **Every gap
 * has one**, live, paused or closed; a live gap comes from the shared store, a
 * recent (closed) gap is rebuilt read-only.
 *
 * The store is module-level, so a `force` counter re-renders after Pause / Resume
 * / We'll-fill-it / Book — the same pattern the recall list and the holds use.
 */
export function GapDetailPage() {
  const navigate = useNavigate();
  const { gapId } = useParams<{ gapId: string }>();
  const [, force] = useState(0);

  const gap = gapId === undefined ? undefined : (gapById(gapId) ?? recentGapDetail(gapId));
  if (gap === undefined) return <Navigate to="/ai-team/gap-filler" replace />;

  const rerender = () => { force((n) => n + 1); };

  return (
    <GapDetailView
      gap={gap}
      onBack={() => { void navigate('/ai-team/gap-filler'); }}
      onPause={() => { pauseGap(gap.id, 'You', 'just now'); rerender(); }}
      onResume={() => { resumeGap(gap.id); rerender(); }}
      onFillOurselves={() => { fillOurselves(gap.id); rerender(); }}
      onBook={(candidateId) => { bookGap(gap.id, candidateId); rerender(); }}
      onSkip={(candidateId) => { skipCandidate(gap.id, candidateId); rerender(); }}
      onReadConversation={() => { void navigate('/communications?agent=gap-filler'); }}
      onFixContact={() => { void navigate('/patients'); }}
    />
  );
}
